import React, { useState } from "react";
import { useDetectClickOutside } from "react-detect-click-outside";

const FormField = ({ children, className, DropWrapperContent, dropProps }) => {
  const [isOpen, setIsOpen] = useState(0);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  const CloseToggle = () => {
    setIsOpen(0);
  };
  const ref = useDetectClickOutside({ onTriggered: CloseToggle });

  return (
    <div
      ref={ref}
      onClick={() => {
        setIsOpen(1);
      }}
      className={
        "border-b w-full ml:w-auto text-center cursor-pointer relative lg:border-b-0 lg:border-r border-brand-gray-7 px-5 py-2 ml:py-5 min-w-[175px] lg:first:pl-0 group " +
        (className ? className : "")
      }
    >
      <div className="flex justify-center sm:justify-between items-center ">
        {children}
      </div>
      {DropWrapperContent && (
        <div
          className={
            `absolute border-t-2 z-30 top-full py-4 px-6 bg-white w-full right-0 shadow-xl transition-transform transform-gpu origin-top min-w-[300px] ` +
            (isOpen ? "scale-y-100" : "scale-y-0")
          }
        >
          {
            <DropWrapperContent
              {...dropProps}
              close={CloseToggle}
            ></DropWrapperContent>
          }
        </div>
      )}
    </div>
  );
};

export default FormField;
